Ext.define('SA.CrosstabAttributes', {
    constructor({top, left}) {
        this.top = top;
        this.left = left;
    },

    append({attribute, top}) {
        if (this.has(attribute)) {
            return;
        }

        this.getSide({top}).push(attribute);
    },

    clear() {
        this.top = [];
        this.left = [];
    },

    clone() {
        var params = {top: this.top.slice(), left: this.left.slice()};

        return new SA.CrosstabAttributes(params);
    },

    get({top: topIndex, left: leftIndex}) {
        return this.top[topIndex] || this.left[leftIndex];
    },

    getAll() {
        return [...this.top, ...this.left];
    },

    getArrays() {
        return {top: this.top, left: this.left};
    },

    getCounts() {
        return {top: this.top.length, left: this.left.length};
    },

    getPosition(attribute) {
        if (this.top.includes(attribute)) {
            return {top: true, index: this.top.indexOf(attribute)};
        }

        return {left: true, index: this.left.indexOf(attribute)};
    },

    getSide({top}) {
        return top ? this.top : this.left;
    },

    has(attribute) {
        if (Ext.isObject(attribute)) {
            let {top: topAttribute, left: leftAttribute} = attribute;

            return topAttribute ? this.top.includes(topAttribute) : this.left.includes(leftAttribute);
        }

        return this.getAll().includes(attribute);
    },

    hasPosition(attribute, position) {
        var currentPosition = this.getPosition(attribute),
            sameIndex = position.index === currentPosition.index,
            sameSection = (position.top && currentPosition.top) || (position.left && currentPosition.left);

        return sameIndex && sameSection;
    },

    isSingleAttributeInSide(attribute) {
        var countForSide = this.getPosition(attribute).top ? this.top.length : this.left.length;

        return countForSide === 1;
    },

    moveTo(attribute, position) {
        var {top, index} = position;

        this.remove(attribute);
        this.getSide({top}).splice(index, 0, attribute);
    },

    remove(attribute) {
        Ext.Array.remove(this.top, attribute);
        Ext.Array.remove(this.left, attribute);
    },

    toggle({attribute, side}) {
        this.remove(attribute);

        if (side.top || side.left) {
            this.append({attribute, top: side.top});
        }
    }
});